import { useContext } from "react";
import { SignalRContext } from "../SignalRContext";
import { SignalRClientMethod, SignalRServerMethod } from "../constants";
import { SignalRMeetingsContext } from "./SignalRMeetingsContext";

interface IProps {
  children?: React.ReactNode;
}

const SignalRMeetingsProvider = (props: IProps) => {
  const context = useContext(SignalRContext);

  return (
    <SignalRMeetingsContext.Provider
      value={{
        sendRefetchAgendaItemContent: (...args) =>
          context.invoke(SignalRServerMethod.SendRefetchAgendaItemContent, args),
        sendRefetchTeamMeetingsList: (...args) => context.invoke(SignalRServerMethod.SendRefetchTeamMeetingsList, args),
        sendRefetchMeetingListItem: (...args) => context.invoke(SignalRServerMethod.SendRefetchMeetingListItem, args),
        sendRefetchMeetingNotes: (...args) => context.invoke(SignalRServerMethod.SendRefetchMeetingNotes, args),
        sendRefetchMeetingParticipants: (...args) =>
          context.invoke(SignalRServerMethod.SendRefetchMeetingParticipants, args),
        sendEndMeeting: (...args) => context.invoke(SignalRServerMethod.SendEndMeeting, args),
        onShouldRefetchAgendaItemContent: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchAgendaItemContent, handler),
        onShouldRefetchMeetingListItem: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchMeetingListItem, handler),
        onShouldRefetchMeetingNotes: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchMeetingNotes, handler),
        onShouldRefetchMeetingParticipants: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchMeetingParticipants, handler),
        onShouldRefetchTeamMeetingsList: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchTeamMeetingsList, handler),
        onShouldEndMeeting: (handler) => context.registerHandler(SignalRClientMethod.ShouldEndMeeting, handler),
        offShouldRefetchAgendaItemContent: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchAgendaItemContent, handler),
        offShouldRefetchMeetingListItem: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchMeetingListItem, handler),
        offShouldRefetchMeetingNotes: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchMeetingNotes, handler),
        offShouldRefetchMeetingParticipants: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchMeetingParticipants, handler),
        offShouldRefetchTeamMeetingsList: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchTeamMeetingsList, handler),
        offShouldEndMeeting: (handler) => context.registerHandler(SignalRClientMethod.ShouldEndMeeting, handler),
        onRefetchActiveMeetingNotifications: (handler) =>
          context.registerHandler(SignalRClientMethod.RefetchActiveMeetingNotifications, handler),
        offRefetchActiveMeetingNotifications: (handler) =>
          context.unregisterHandler(SignalRClientMethod.RefetchActiveMeetingNotifications, handler),
      }}
    >
      {props.children}
    </SignalRMeetingsContext.Provider>
  );
};

export { SignalRMeetingsProvider };
